import Pagination from './Pagination.vue'
export default Pagination


// WEBPACK FOOTER //
// ./src/components/Pagination/index.js